export const allowedFileTypes = ['.bmp', '.gif', '.jpeg', '.jpg', '.png'];
